<template>
    <v-container class="gradient-bg">
        <v-row>
            <v-col cols="12" class="text-center">
                <h2 class="display-1 font-weight-bold mb-6">¿Por qué elegirnos?</h2>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-for="benefit in benefits" :key="benefit.title" cols="12" md="4">
                <v-card class="pa-4 text-center">
                    <v-icon size="64" color="primary">{{ benefit.icon }}</v-icon>
                    <h3 class="title font-weight-bold mt-4">{{ benefit.title }}</h3>
                    <p>{{ benefit.description }}</p>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            benefits: [
                { title: 'Experiencia', icon: 'mdi-chart-line', description: 'Más de 10 años en el mercado.' },
                { title: 'Innovación', icon: 'mdi-lightbulb-on', description: 'Siempre a la vanguardia tecnológica.' },
                { title: 'Soporte 24/7', icon: 'mdi-headset', description: 'Asistencia técnica en todo momento.' },
            ],
        };
    },
};
</script>

<style scoped>
.gradient-bg {
    background: linear-gradient(135deg, #6a11cb, #2575fc);
    color: white;
}
</style>